import React from "react";
import { Zap } from "lucide-react";
import { FOOTER } from "@/constants/testIds";
import { BUSINESS, LOGO_URL } from "@/data/siteData";

export default function Footer() {
  return (
    <footer data-testid={FOOTER.root} className="border-t border-[var(--pe-line)] bg-[var(--pe-black)]">
      <div className="container-pe py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Perez Electric" className="h-12 w-12 object-contain rounded-sm bg-[var(--pe-black)] border border-[var(--pe-line)] p-0.5" />
              <div>
                <div className="font-display tracking-[0.18em] text-white">PEREZ ELECTRIC</div>
                <div className="font-mono text-[10px] tracking-[0.28em] text-[var(--pe-gold)] uppercase">Licensed · Insured</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-[var(--pe-muted)] max-w-sm leading-relaxed">
              {BUSINESS.slogan}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[var(--pe-muted)] mb-4">Contact</div>
            <ul className="space-y-2 text-sm text-white">
              <li><a href={BUSINESS.phoneHref} className="hover:text-[var(--pe-gold)] transition-colors">{BUSINESS.phone}</a></li>
              <li><a href={BUSINESS.emailHref} className="hover:text-[var(--pe-gold)] transition-colors break-all">{BUSINESS.email}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[var(--pe-muted)] mb-4">Specialties</div>
            <div className="flex flex-wrap gap-2">
              {["EV Chargers", "Panel Upgrades", "Lighting", "Smart Home", "Commercial", "New Builds"].map((t) => (
                <span key={t} className="text-xs font-mono tracking-[0.16em] uppercase border border-[var(--pe-line-strong)] text-[var(--pe-muted)] px-2.5 py-1.5">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="pe-bolt-line mt-12 mb-6" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs font-mono tracking-[0.18em] uppercase text-[var(--pe-muted)]">
            © {new Date().getFullYear()} Perez Electric · All rights reserved
          </p>
          <p className="text-xs font-mono tracking-[0.18em] uppercase text-[var(--pe-muted)] flex items-center gap-2">
            <Zap className="h-3.5 w-3.5 text-[var(--pe-gold)]" /> Powered by Precision · Wired for Excellence
          </p>
        </div>
      </div>
    </footer>
  );
}
